import { render, staticRenderFns } from "./TrainRefundPerson.vue?vue&type=template&id=46d1c792&scoped=true&"
import script from "./TrainRefundPerson.vue?vue&type=script&lang=js&"
export * from "./TrainRefundPerson.vue?vue&type=script&lang=js&"
import style0 from "./TrainRefundPerson.vue?vue&type=style&index=0&id=46d1c792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d1c792",
  null
  
)

export default component.exports